<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "MglGeolocateControl",
  inject: ["map"],
  props: {
    position: {
      type: String,
      default: "top-right",
    },
    trackUserLocation: {
      type: Boolean,
      default: false,
    },
    showUserLocation: {
      type: Boolean,
      default: true,
    },
  },
  render: (h) => h(),
  data() {
    return {
      control: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.map) return;
      this.control = new mapboxgl.GeolocateControl({
        positionOptions: { enableHighAccuracy: true },
        trackUserLocation: this.trackUserLocation,
        showUserLocation: this.showUserLocation,
      });
      this.map.addControl(this.control, this.position);
    });
  },
  beforeDestroy() {
    if (this.map && this.control) {
      this.map.removeControl(this.control);
    }
  },
};
</script>
